import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const ButtonContainer = styled("div", {
    shouldForwardProp: prop => prop !== "applyMarginCompensation",
})<{applyMarginCompensation?: boolean}>`
    display: flex;
    z-index: 1;
    @media (min-width: ${breakpoints.values.md}px) {
        ${({applyMarginCompensation}) => (applyMarginCompensation ? "margin-left: 0.5rem;" : "")}
    }
    
]
`

export const ImageContainer = styled("button")`
    cursor: pointer;
    display: flex;
    padding: 0.438rem 0.688rem;
    background-color: transparent;
    border: none;
    &:active {
        background-color: transparent;
        border: none;
    }
    @media (min-width: ${breakpoints.values.md}px) {
        padding: 0.5rem;
    }
`

export const Img = styled("img", {
    shouldForwardProp: prop => prop !== "isSecure",
})<{isSecure?: boolean}>`
    display: flex;
    border-radius: 50%;
    width: 1.375rem;
    height: 1.375rem;
    background: ${({isSecure}) =>
        isSecure
            ? ({theme}) => theme.uxfabric.components.appBar.brandBar.default.button.outlined.primary.enabled.borderColor
            : ({theme}) =>
                  theme.uxfabric.components.appBar.globalBar.default.button.outlined.primary.enabled.borderColor};

    border: 0.0625rem solid;
    border-color: ${({isSecure}) =>
        isSecure
            ? ({theme}) => theme.uxfabric.components.appBar.brandBar.default.button.outlined.primary.enabled.borderColor
            : ({theme}) =>
                  theme.uxfabric.components.appBar.globalBar.default.button.outlined.primary.enabled.borderColor};

    @media (min-width: ${breakpoints.values.md}px) {
        width: 1.25rem;
        height: 1.25rem;
    }
`
